
import { LeadContact } from "@/services/leadContactsService";
import AddContactDialog from "./AddContactDialog";
import { 
  AlertDialog, 
  AlertDialogAction, 
  AlertDialogCancel, 
  AlertDialogContent, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogHeader, 
  AlertDialogTitle 
} from "@/components/ui/alert-dialog";

interface ContactsDialogManagerProps {
  selectedContact: LeadContact | null;
  isEditDialogOpen: boolean;
  onCloseEditDialog: () => void;
  onContactUpdated: () => void;
  departments: string[];
  contactToDelete: LeadContact | null;
  onDeleteContact: () => void;
  onCancelDelete: () => void;
  // Add contact dialog props
  isAddDialogOpen?: boolean;
  onCloseAddDialog?: () => void;
}

const ContactsDialogManager = ({
  selectedContact,
  isEditDialogOpen,
  onCloseEditDialog,
  onContactUpdated,
  departments,
  contactToDelete,
  onDeleteContact,
  onCancelDelete,
  isAddDialogOpen = false,
  onCloseAddDialog = () => {}
}: ContactsDialogManagerProps) => {
  return (
    <>
      {/* Add contact dialog */}
      <AddContactDialog
        open={isAddDialogOpen}
        onOpenChange={onCloseAddDialog}
        onContactAdded={onContactUpdated}
        departments={departments.filter(d => d !== "All")}
      />
      
      {/* Edit contact dialog - using same AddContactDialog */}
      <AddContactDialog
        open={isEditDialogOpen}
        onOpenChange={onCloseEditDialog}
        onContactAdded={onContactUpdated}
        departments={departments.filter(d => d !== "All")}
        editContact={selectedContact}
      />
      
      {/* Delete confirmation dialog */}
      <AlertDialog open={!!contactToDelete} onOpenChange={(open) => !open && onCancelDelete()}>
        <AlertDialogContent aria-describedby="delete-contact-description">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete Contact</AlertDialogTitle>
            <AlertDialogDescription id="delete-contact-description">
              Are you sure you want to delete {contactToDelete?.first_name} {contactToDelete?.last_name}? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={onDeleteContact}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default ContactsDialogManager;
